import clsx from 'clsx';
import React, { FC } from 'react';
import '../../App.scss';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

import next from '../../assets/icons/next.svg';
import back from '../../assets/icons/back.svg';

interface INavButtonProps {
  text: string;
  type: 'back' | 'next' | 'ok';
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | object;
}

const NavButton: FC<INavButtonProps> = ({ text, type, onClick }) => {
  const { t } = useTranslation();

  const arrow = {
    next,
    back,
    ok: null,
  };
  return (
    <button className={clsx(styles.button, styles[type])} onClick={onClick}>
      {t(text)}
      {type !== 'ok' && <img src={arrow[type]} alt={type} />}
    </button>
  );
};

export default NavButton;
